module.exports = __webpack_public_path__ + "img/lk-menu-exit.745cc37c.svg";